<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$router.push('/entries/services/new')">
          <i class="plus icon"></i> Novo Serviço
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="services-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="services-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="navToServiceForm" />

  </div>

</template>

<script>
  
  import SrvService from "@/services/srv-service"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "ServicesPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Serviços",
        service: new SrvService(),
        attributes: ["id", "description"],
        fields: [          
          { prop: "description", label: "Nome do Serviço" },
          { prop: "types", label: "Tipos", render: this.renderTypes, sortDisabled: true },
        ],
      }
    },

    methods: {

      renderTypes(service) {

        let labels = ""
        let icon = ""

        labels += `<div class="ui small labels">`

        for (let type of service.types) {
          icon = `<i class="${SrvService.TYPE_ICONS[type.icon].icon} m-r-5"></i>`
          labels += `<div class="ui label">${icon} ${type.description}</div>`
        }

        labels += `</div>`

        return labels
      },

      navToServiceForm(data) {
        this.$router.push("/entries/services/" + data.row.id)
      },
    },
  }

</script>
